var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxGridVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-grid-vertical.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66663 6.66797H7.33329V9.33463H4.66663V6.66797ZM4.66663 2.66797H7.33329V5.33464H4.66663V2.66797ZM4.66663 10.668H7.33329V13.3346H4.66663V10.668ZM8.66663 6.66797H11.3333V9.33463H8.66663V6.66797ZM8.66663 2.66797H11.3333V5.33464H8.66663V2.66797ZM8.66663 10.668H11.3333V13.3346H8.66663V10.668Z",
    fill: "#636D65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGridVertical);
export default __webpack_public_path__ + "static/media/bx-grid-vertical.6b1ac0c20fef2b72bbe9ab683d1fcc4b.svg";
export { ForwardRef as ReactComponent };